<template>
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['tutorial_parchi_divertimento']"/>

    <!-- Pagina di login per il servizio -->
    <TsLoginPage :service_title="service_title" :service="service" :cluster="cluster" :comp_credito="comp_credito"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'
import TsLoginPage from '@/components/tantosvago/TsLoginPage'

export default {
  name: 'TsTicket',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Parchi di divertimento", link : 'conv-ticket' } ],

        // variabili che definiscono il servizio experiece con la quale
        // configuriamo la pagina di login.
        service_title: "Parchi di divertimento",
        service: "ticket",
        cluster: "home",
        comp_credito: "totale"
    }
  },
  components: {
    PageTagline,
    TutorialContestuale,
    TsLoginPage
  }
}
</script>

<style scoped></style>